import { render, staticRenderFns } from "./TodayMeetingBadges.vue?vue&type=template&id=59cd636e&scoped=true"
import script from "./TodayMeetingBadges.vue?vue&type=script&lang=js"
export * from "./TodayMeetingBadges.vue?vue&type=script&lang=js"
import style0 from "./TodayMeetingBadges.vue?vue&type=style&index=0&id=59cd636e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd636e",
  null
  
)

export default component.exports